import React from "react";
import "./MiningTypeAbout.css";
import RentTypeLogo from "../../../assets/miningtypelogo2.png";

function MiningTypeAbout() {
  return (
    <div className="mining-type-about-container">
         <a href="https://minethunder.com" target="_blank" rel="noopener noreferrer">
          <div className="mining-type-about-logo-container">
            <img
              src={RentTypeLogo}
              alt="RentType Logo"
              className="mining-type-about-logo"
            />
          </div>
        </a>

        <div className="mining-type-about-text-container">
          <h1 className="mining-type-about-main-title">MineThunder.com</h1>
          <p className="mining-type-about-descriptions">
          MineThunder.com isn't merely a digital domain; it's a sanctuary for
            miners, innovators, and pioneers redefining the cryptocurrency
            mining landscape.
            <br />
            <br />
            Visualize a nexus of servers, a virtual realm where digital
            currencies are unearthed through cutting-edge technology. Our
            resolute servers encapsulate the blueprint of financial evolution.
            <br />
            <br />
            In collaboration with esteemed ASIC firmware luminaries,
            MineThunder.com emerges as a beacon of trust, offering proven
            solutions that epitomize victory in the digital gold rush.
          </p>
           
        </div>
     </div>
  );
}

export default MiningTypeAbout;
